import { useContext } from 'react';
import { AuthContext } from '@/AuthProvider.tsx';

const useAuth = () => useContext(AuthContext);

export default useAuth;
